"use client";
import { jsx as l, jsxs as p, Fragment as k } from "react/jsx-runtime";
import { useState as h, useMemo as S, useRef as g } from "react";
import { generatePrefixedUniqueId as u } from "../utils/generate-uid.js";
import { useInkeepConfig as x } from "../providers/config-provider.js";
import { dequal as L } from "dequal";
function A() {
  const { baseSettings: n } = x(), [s, i] = h([]), r = C(n.theme.styles), { customStyles: y, linksCount: c } = S(() => {
    if (!r || !Array.isArray(r)) return { customStyles: null, loaded: !0 };
    const { links: o, styleSheets: d } = r.reduce(
      (e, t) => (t.type === "link" ? e.links.push(t) : t.type === "style" && e.styleSheets.push(t), e),
      { links: [], styleSheets: [] }
    ), m = d.map((e) => /* @__PURE__ */ l(
      "style",
      {
        type: "text/css",
        dangerouslySetInnerHTML: { __html: e.value }
      },
      e.key ?? u("link_")
    )), a = o.map((e) => {
      const t = e.key ?? u("stylesheet_");
      return /* @__PURE__ */ l(
        "link",
        {
          id: t,
          rel: "stylesheet",
          type: "text/css",
          href: e.value,
          onLoad: () => {
            i((f) => [.../* @__PURE__ */ new Set([...f, e.value])]);
          }
        },
        t
      );
    });
    return {
      customStyles: /* @__PURE__ */ p(k, { children: [
        a,
        m
      ] }),
      linksCount: o.length
    };
  }, [r]);
  return {
    customStyles: y,
    loaded: s.length >= (c ?? 0)
    // >= in case a url is removed
  };
}
function C(n) {
  const s = g(void 0);
  return L(s.current, n) || (s.current = n), s.current;
}
export {
  C as useCompareMemoize,
  A as useCustomStyles
};
